import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'

import auth from './modules/auth'
import onboarding from './modules/onboarding'
import settings from './modules/settings'
import newOnboarding from './modules/newOnboarding'
import mfa from './modules/mfa'

Vue.use(Vuex)

const vuexCookie = new VuexPersistence({
    restoreState: (key, storage) => Cookies.getJSON(key),
    saveState: (key, state, storage) => Cookies.set(key, state, {
      expires: 1,
      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
    }),
    // IMPORTANTE: o módulo `mfa` NÃO deve ser persistido em cookie. Ele guarda o
    // `mfaSessionToken` (pre-auth JWT) e deve viver apenas em memória durante o
    // fluxo /login -> /login/mfa. Refresh da aba intencionalmente descarta o
    // estado e força o usuário a re-autenticar.
    modules: ['auth', 'settings']
})

var store = new Vuex.Store({
    modules: {
      auth,
      onboarding,
      settings,
      newOnboarding,
      mfa
    },
    plugins: [vuexCookie.plugin]
})

store.check = function () {
  return Cookies.getJSON('vuex')
}

Vue.$store = store

export default store
